// extracted by mini-css-extract-plugin
export default {"custom-modal-dialog":"CustomModal_custom-modal-dialog__-5b9Y","calender-modal":"CustomModal_calender-modal__KO-Fc"};